module.exports = __webpack_public_path__ + "task_teal.ba77d25111b72770d9b3.svg";


//////////////////
// WEBPACK FOOTER
// /Users/hrushabhmakwana/Documents/CAM/CreditRepairMenAngular/src/assets/modules/dummy-assets/common/img/icon/svg_icon/task_teal.svg
// module id = ../../../../../src/assets/modules/dummy-assets/common/img/icon/svg_icon/task_teal.svg
// module chunks = styles